import { render } from "./AboutUsView.vue?vue&type=template&id=74b6ccfc&scoped=true"
import script from "./AboutUsView.vue?vue&type=script&lang=js"
export * from "./AboutUsView.vue?vue&type=script&lang=js"

import "./AboutUsView.vue?vue&type=style&index=0&id=74b6ccfc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b6ccfc"]])

export default __exports__